import React from 'react'
import { Link } from 'gatsby'
import { Container, Section, Subtitle } from 'bloomer'
import styled from 'styled-components'

import FontAwesome from './fontawesome'

const Card = styled.div`
  align-items: center;
  display: flex;
  background-color: white;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 2px 4px;
  height: 100%;
  justify-content: center;
  margin: 0 auto;
  padding: 1rem 1.5rem;
  border-radius: 22px;
  transition: box-shadow 250ms ease 0s;
  width: 320px;

  .fa-2x {
    color: #0066f1; !important;
  }

  .next-up-link {
    color: #0066f1; !important;
  }

  .subtitle.is-4 {
    font-size: 1.25rem;
  }

  :active,
  :focus,
  :hover {
    box-shadow: rgba(0, 0, 0, 0.1) 0px 12px 24px;

    .fa-2x {
      color: #0066f1; !important;
    }
  }

  @media only screen and (min-width: 32rem) {
    width: 480px;

    .subtitle.is-4 {
      font-size: 1.75rem;
    }
  }
`

const BottomLine = styled.hr`
  background: rgba(0, 0, 0, 0.15);
  border: none;
  display: block;
  height: 1px;
  margin: 4rem 0 0 0;
`

const TopLine = styled.hr`
  background: rgba(0, 0, 0, 0.15);
  border: none;
  display: block;
  height: 1px;
  margin: 0 0 4rem 0;
`

const Next = ({ className, style, to, title }) => (
  <Section className={className} isSize={'small'} style={style}>
    <Container>
      <TopLine />
      <Link to={to}>
        <Card>
          <Subtitle
            className={`next-up-link`}
            isSize={4}
            style={{ fontWeight: 700 }}
          >
            {title}
          </Subtitle>
          <FontAwesome
            alt={`learn more about ${title}`}
            aria-label={`learn more about ${title}`}
            icon={['fa', 'arrow-alt-circle-right']}
            size={'2x'}
            style={{ marginLeft: '0.5rem' }}
          />
        </Card>
      </Link>
      <BottomLine />
    </Container>
  </Section>
)

export default Next
